export default {
  __name: 'SidebarChangeTypeItem',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      default: ''
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    }
  },
  setup(__props) {
    return {
      __sfc: true
    };
  }
};